import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import RemoveVehicleTypeModal from 'src/components/global-settings/RemoveVehicleTypeModal'
import { removeVehicleType, getVehicleCreateOptions } from 'src/state/actions/vehicles'
import { getOrganization, getVehicleType } from 'src/state/selectors'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    id: ownProps.match.params.id,
    setting: getVehicleType(ownProps.match.params.id, state)
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    removeVehicleType: (id: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeVehicleType(id)).then(() => {
          dispatch(getVehicleCreateOptions()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveVehicleTypeModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/RemoveVehicleTypeModal.ts